<template>
  <div class="search-box">
    <input v-model="keyword" class="search-input" type="text" placeholder="请输入关键词">
    <a class="search-btn" href="javascript:void(0)" @click="ClickSearch()">搜索</a>
  </div>
</template>

<script>
export default {
  data(){
    return {
      keyword:''
    }
  },
  methods:{
    ClickSearch(){
      this.$emit('keyword',this.keyword);
    }
  }
}
</script>

<style>

</style>